import React, { PropsWithChildren } from 'react'
import { makeStyles } from '@material-ui/core'
import { Button, Icon, Typography } from 'foundations-library/components'

const jss = () => ({
    content: {
        height: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    iconContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    icon: {
        marginBottom: '20px'
    },
    genericText: {
        marginBottom: ({ children }) => children && '20px'
    },
    buttonContainer: {
        marginTop: '30px',
        display: 'flex',
        justifyContent: 'center'
    },
    button: {
        minWidth: '90px'
    }
})

/**
 *
 */
export type ErrorContentPropsType = {
    title?: string,
    subtitle?: string,
    buttonText?: string,
    onConfirm?(): any,
    'data-testid'?: string
}

const useStyles = makeStyles(jss)

/**
 *
 */
const ErrorDialogContent = ({
    title = 'Oops something went wrong!',
    subtitle,
    buttonText = 'Ok',
    onConfirm,
    children,
    ...props
}: PropsWithChildren<ErrorContentPropsType>): JSX.Element => {
    const styles = useStyles({ children })
    return <div className={styles.content} data-testid={`${props['data-testid']}-content`}>
        <div className={styles.iconContainer}><Icon size={80} color='destructive-600' name='cancel' className={styles.icon} data-testid={`${props['data-testid']}-icon`} /></div>
        <div className={styles.genericText} data-testid={`${props['data-testid']}-generic-content`}>
            <Typography variant='h6' data-testid={`${props['data-testid']}-title`}>
                {title}
            </Typography>
            {subtitle && <Typography variant='body1' data-testid={`${props['data-testid']}-subtitle`}>
                {subtitle}
            </Typography>}
        </div>
        {children}
        {
            onConfirm && <div className={styles.buttonContainer}>
                <Button onClick={onConfirm} color='neutral' className={styles.button} data-testid='confirm-button'>
                    {buttonText}
                </Button>
            </div>
        }
    </div>
}

export default ErrorDialogContent
